// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qp14","left":"styles_left__2_Qp_","desktopActions":"styles_desktopActions__3eM5M","title":"styles_title__2Cdug"};